import { entity, persistence } from "simpler-state"

export type FilterCategoryKey = "customers" | "retailers" | "promotionTypes" | "products"

export interface PromoCalendarFilterPreferences {
  isFiltersVisible: boolean
  collapseState: Record<FilterCategoryKey, boolean>
}

const INITIAL_PROMO_CALENDAR_FILTER_PREFERENCES: PromoCalendarFilterPreferences = {
  isFiltersVisible: false,
  collapseState: {
    customers: true,
    retailers: true,
    promotionTypes: true,
    products: true,
  },
}

function deserializeFilterPreferences(blob: string): PromoCalendarFilterPreferences {
  try {
    const parsed = JSON.parse(blob)
    const collapseState = parsed?.collapseState ?? {}
    return {
      isFiltersVisible: typeof parsed?.isFiltersVisible === "boolean"
        ? parsed.isFiltersVisible
        : INITIAL_PROMO_CALENDAR_FILTER_PREFERENCES.isFiltersVisible,
      collapseState: {
        customers: typeof collapseState.customers === "boolean"
          ? collapseState.customers
          : INITIAL_PROMO_CALENDAR_FILTER_PREFERENCES.collapseState.customers,
        retailers: typeof collapseState.retailers === "boolean"
          ? collapseState.retailers
          : INITIAL_PROMO_CALENDAR_FILTER_PREFERENCES.collapseState.retailers,
        promotionTypes: typeof collapseState.promotionTypes === "boolean"
          ? collapseState.promotionTypes
          : INITIAL_PROMO_CALENDAR_FILTER_PREFERENCES.collapseState.promotionTypes,
        products: typeof collapseState.products === "boolean"
          ? collapseState.products
          : INITIAL_PROMO_CALENDAR_FILTER_PREFERENCES.collapseState.products,
      },
    }
  } catch {
    return INITIAL_PROMO_CALENDAR_FILTER_PREFERENCES
  }
}

export const PromoCalendarFilterPreferencesState = entity<PromoCalendarFilterPreferences>(
  INITIAL_PROMO_CALENDAR_FILTER_PREFERENCES,
  [persistence("promo_calendar_filter_preferences", { deserializeFn: deserializeFilterPreferences })]
)

export function setPromoCalendarFiltersVisible(isVisible: boolean) {
  PromoCalendarFilterPreferencesState.set((previous) => ({
    ...previous,
    isFiltersVisible: isVisible,
  }))
}

export function setPromoCalendarCategoryCollapsed(category: FilterCategoryKey, isCollapsed: boolean) {
  PromoCalendarFilterPreferencesState.set((previous) => ({
    ...previous,
    collapseState: {
      ...previous.collapseState,
      [category]: isCollapsed,
    },
  }))
}
